
const body = document.querySelector(`body`);
const actionDemoElement = body.querySelector(`.actionDemo`);

const initFAQDropDown = () => {
  const gridDropdownList = body.querySelectorAll(`.grid__dropdown`);

  gridDropdownList.forEach((listItem) => {
    const parent = listItem.parentElement;
    parent.addEventListener(`click`, () => {
      const dropdownArrowElement = parent.querySelector(`.grid__dropdown`);
      const dropdownText = parent.nextElementSibling;
      dropdownArrowElement.classList.toggle(`grid__dropdown--dropped`);
      dropdownText.classList.toggle(`grid__dropdown-text--show`);
    }, true);
  });
};

const initVideo = (url, selector) => {
  selector = selector || `.button__promo--right`;
  let videoFrameElement = ``;
  const videoButtonElement = body.querySelector(selector);

  if (videoButtonElement) {
    const closeVideo = () => {
      videoFrameElement.style.display = `none`;
      deleteVideoElement();
      videoFrameElement.removeEventListener(`click`, closeVideo);
    };

    const openVideo = () => {
      fillFragment(url);
      videoFrameElement = body.querySelector(`.promo__video-container:not(.promo__video)`);
      videoFrameElement.style.display = `block`;
      videoFrameElement.addEventListener(`click`, closeVideo);
    };

    videoButtonElement.addEventListener(`click`, openVideo);
  }
};

const createVideoElement = (url) => {
  const similarVideoTemplateElement = body.querySelector(`template`).content;
  const video = similarVideoTemplateElement.cloneNode(true);
  const videoFileElement = video.querySelector(`.promo__video`);
  videoFileElement.src = url;
  return video;
};

const deleteVideoElement = () => {
  const videoContainerElement = body.querySelector(`.promo__video-container`);
  videoContainerElement.remove();
};

const fillFragment = (url) => {
  const fragment = document.createDocumentFragment();
  const promoBlockElement = body.querySelector(`.promo`);
  fragment.appendChild(createVideoElement(url));
  promoBlockElement.appendChild(fragment);
};

const submitTime = (selector) => {
  const formSubmitElements = body.querySelectorAll(selector || `.form__contactSubmit`);

  if (formSubmitElements) {
    formSubmitElements.forEach((element) => {
      const inputTimeHidden = () => {
        const input = document.createElement(`input`);
        input.name = `browserDate`;
        input.type = `hidden`;
        input.value = new Date();
        return input;
      };

      const inputURLHidden = () => {
        const input = document.createElement(`input`);
        input.name = `url`;
        input.type = `hidden`;
        input.value = window.location.href;
        return input;
      };

      element.addEventListener(`submit`, () => {
        element.appendChild(inputTimeHidden());
        element.appendChild(inputURLHidden());

        const gaEvent = element.dataset.gaEvent || 'event-to-ga';
        const gaEventCategory = element.dataset.gaEventCategory || 'click';
        const gaEventAction = element.dataset.gaEventAction || 'sendform';

        if ('dataLayer' in window) {
          // send event to GTM
          dataLayer.push({
            'event': gaEvent,
            'eventCategory': gaEventCategory,
            'eventAction': gaEventAction
          });
        }
      });
    });

  }
};

const isVisibile = (element) => {
  const documentTop = window.scrollY;
  const documentBottom = documentTop + window.innerHeight;
  const elementTop = element.offsetTop;
  return (elementTop < documentBottom);
};

const actionDemoOnclick = () => {
  const formElement = body.querySelector(`.form`);
  const firstNameElement = formElement.querySelector(`#firstName`);

  actionDemoElement.addEventListener(`click`, (evt) => {
    evt.preventDefault();
    formElement.scrollIntoView({ behavior: `smooth` });
  });

  document.addEventListener(`scroll`, () => {
    if (isVisibile(formElement)) {
      actionDemoElement.style.transform = `translateY(100%)`;
      setTimeout(() => {
        firstNameElement.focus();
      }, 500);
    } else {
      actionDemoElement.style.transform = `translateY(0%)`;
    }
  });
};

if (actionDemoElement) {
  actionDemoOnclick();
}

window.initVideo = initVideo;
window.initFAQDropDown = initFAQDropDown;
window.submitTime = submitTime;
